export const GET_USER = 'user/GET_USER';
export const BANKING_DETAILS_VERIFYING = 'user/BANKING_DETAILS_VERIFYING';
export const UPDATE_USER_SETTINGS_SUCCESS = 'user/UPDATE_USER_SETTINGS_SUCCESS';
export const BANKING_DETAILS_SUCCESS = 'user/BANKING_DETAILS_SUCCESS';

export const ADD_DEPENDENT_SUCCESS = 'user/ADD_DEPENDENT_SUCCESS';
export const UPDATE_DEPENDENT_SUCCESS = 'user/UPDATE_DEPENDENT_SUCCESS';
export const REMOVE_DEPENDENT_SUCCESS = 'user/REMOVE_DEPENDENT_SUCCESS';

export const ADD_BENEFICIARY_SUCCESS = 'user/ADD_BENEFICIARY_SUCCESS';
export const UPDATE_BENEFICIARY_SUCCESS = 'user/UPDATE_BENEFICIARY_SUCCESS';
export const REMOVE_BENEFICIARY_SUCCESS = 'user/REMOVE_BENEFICIARY_SUCCESS';
export const UPDATE_CURRENT_BENEFICIARIES = 'user/UPDATE_CURRENT_BENEFICIARIES';

export const ADD_TRUSTEE_SUCCESS = 'user/ADD_TRUSTEE_SUCCESS';
export const UPDATE_TRUSTEE_SUCCESS = 'user/UPDATE_TRUSTEE_SUCCESS';
export const REMOVE_TRUSTEE_SUCCESS = 'user/REMOVE_TRUSTEE_SUCCESS';

export const REMOVE_NOTIFICATION_SUCCESS = 'user/REMOVE_NOTIFICATION_SUCCESS';

export const GET_DEPENDENT = 'user/GET_DEPENDENT';
export const SET_CURRENT_SIDEBAR_ITEM = 'user/SET_CURRENT_SIDEBAR_ITEM';

export const UPDATE_COUNT_CHANGE_REQUESTS_FOR_REVIEW = 'user/UPDATE_COUNT_CHANGE_REQUESTS_FOR_REVIEW';